import { render, staticRenderFns } from "./ingresarSolicitud.vue?vue&type=template&id=8535806c&scoped=true&"
import script from "./ingresarSolicitud.vue?vue&type=script&lang=js&"
export * from "./ingresarSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./ingresarSolicitud.vue?vue&type=style&index=0&id=8535806c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8535806c",
  null
  
)

export default component.exports